import { render } from "./NcrmPbxWorkspace.vue?vue&type=template&id=09cd3db3&scoped=true"
import script from "./NcrmPbxWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmPbxWorkspace.vue?vue&type=script&lang=js"

import "./NcrmPbxWorkspace.vue?vue&type=style&index=0&id=09cd3db3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cd3db3"]])

export default __exports__